export const utf8Decoder = new TextDecoder('utf-8')
export const utf8Encoder = new TextEncoder()
